import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/ScrollToTop';

// Page Components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import JobSubmissionPage from './pages/JobSubmissionPage';
import JobDetailPage from './pages/JobDetailPage';
import JobApplicationsPage from './pages/JobApplicationsPage';
import CVUploadPage from './pages/CVUploadPage';
import TalentAcquisitionPage from './pages/TalentAcquisitionPage';
import HRConsultingPage from './pages/HRConsultingPage';
import ContractStaffingPage from './pages/ContractStaffingPage';
import TechTrainingPage from './pages/TechTrainingPage';
import EmployerBrandingPage from './pages/EmployerBrandingPage';
import JobMatchingPage from './pages/JobMatchingPage';
import SuccessStoriesPage from './pages/SuccessStoriesPage';
import ForCompaniesPage from './pages/ForCompaniesPage';
import ForJobSeekersPage from './pages/ForJobSeekersPage';
import ForEmployersPage from './pages/ForEmployersPage';
import ForContractorsPage from './pages/ForContractorsPage';
import ModeratorLoginPage from './pages/ModeratorLoginPage';
import ModeratorDashboardPage from './pages/ModeratorDashboardPage';
import TalentSeekerDashboardPage from './pages/TalentSeekerDashboardPage';
import DigitalFirstPage from './pages/DigitalFirstPage';
import CloudFirstPage from './pages/CloudFirstPage';
import AIPoweredPage from './pages/AIPoweredPage';
import EdgeReadyPage from './pages/EdgeReadyPage';
import NotFoundPage from './pages/NotFoundPage';

// Context
import { AuthProvider } from './context/AuthContext';
import { JobProvider } from './context/JobContext';

function App() {
  return (
    <AuthProvider>
      <JobProvider>
        <div className="App min-h-screen flex flex-col">
          <ScrollToTop />
          <Header />
          <main className="flex-grow">
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/careers" element={<CareersPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/submit-job" element={<JobSubmissionPage />} />
                <Route path="/job/:id" element={<JobDetailPage />} />
                <Route path="/job-applications" element={<JobApplicationsPage />} />
                <Route path="/cv-upload" element={<CVUploadPage />} />
                <Route path="/talent-acquisition" element={<TalentAcquisitionPage />} />
                <Route path="/hr-consulting" element={<HRConsultingPage />} />
                <Route path="/contract-staffing" element={<ContractStaffingPage />} />
                <Route path="/tech-training" element={<TechTrainingPage />} />
                <Route path="/employer-branding" element={<EmployerBrandingPage />} />
                <Route path="/job-matching" element={<JobMatchingPage />} />
                <Route path="/success-stories" element={<SuccessStoriesPage />} />
                <Route path="/for-companies" element={<ForCompaniesPage />} />
                <Route path="/for-job-seekers" element={<ForJobSeekersPage />} />
                <Route path="/for-employers" element={<ForEmployersPage />} />
                <Route path="/for-contractors" element={<ForContractorsPage />} />
                <Route path="/moderator-login" element={<ModeratorLoginPage />} />
                <Route path="/moderator-dashboard" element={<ModeratorDashboardPage />} />
                <Route path="/talent-seeker-dashboard" element={<TalentSeekerDashboardPage />} />
                <Route path="/digital-first" element={<DigitalFirstPage />} />
                <Route path="/cloud-first" element={<CloudFirstPage />} />
                <Route path="/ai-powered" element={<AIPoweredPage />} />
                <Route path="/edge-ready" element={<EdgeReadyPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </AnimatePresence>
          </main>
          <Footer />
        </div>
      </JobProvider>
    </AuthProvider>
  );
}

export default App; 